module.exports = __webpack_public_path__ + "img/masthead-slide-1.c3e59f07.jpg";